module.exports = __webpack_public_path__ + "assets/sounds/heart-attack.mp3";